<template>
<v-app id="app">
  <app-toolbar></app-toolbar>
  <v-container>    
    <router-view></router-view>
    
  
  </v-container>
  <app-footer></app-footer>

</v-app>
</template>

<script>
import Toolbar from './components/Toolbar.vue'
import Footer from './components/Footer.vue'


export default {
  name: 'App',
  components: {
    appToolbar: Toolbar,
    appFooter: Footer 
    
    
  },
  data () {
    return {
      //
    }
  }
}
</script>
<style>
#app {
background-color: wheat; 
}
</style>



// WEBPACK FOOTER //
// src/App.vue